import React, { useState } from 'react';
import PropTypes from 'prop-types';
import accounting from 'accounting';

import {
	ItemRow,
	RowColumn,
	DeleteX,
} from './shopBagItemStyles';

import ItemImage from './ItemImage';
import ItemDescription from './ItemDescription';
import { serialize, generateTrackingQueryParams } from 'core/utils';

const ShopBagItemProduct = ({ ix, cartProduct, listing, xoLink, store, remove }) => {
	const [transitionIn, setTransitionIn] = useState(true);

	const queryParams = serialize({
		cjt: generateTrackingQueryParams({
			cn: ix + 1,
			sn: "shop-bag",
		})
	});
	const productId = cartProduct.productInstance.product.id;
	const isEcom = cartProduct.productInstance.product.singlePurchasable;
	const productPrice = accounting.formatMoney(cartProduct.price * cartProduct.quantity / 100, cartProduct.currencySymbol);
	let listingHref = isEcom ? xoLink : `/subscription-box/${listing.slug}/?product_id=${productId}&${queryParams}`;
	if (cartProduct?.listing?.slug) {
		// Use product listing URL if available:
		listingHref = `/subscription-box/${cartProduct.listing.slug}/?${queryParams}`;
	}
	const image = cartProduct?.listing?.image ? cartProduct.listing.image : (isEcom && cartProduct.productInstance.product.image ? cartProduct.productInstance.product.image : listing.image);
	return (
		<ItemRow key={`cartProduct-${cartProduct.id}`} in={transitionIn} unmountOnExit={true} timeout={500}>
			<ItemImage
				href={listingHref}
				image={image}
			/>
			<ItemDescription
				href={listingHref}
				name={cartProduct.productInstance.product.name || store.name}
				{...cartProduct}
			/>
			<RowColumn>
				<DeleteX onClick={(e) => {
					e.preventDefault();
					e.stopPropagation();
					setTransitionIn(false);
					remove(cartProduct.id);
				}} />
				<div>{productPrice}</div>
			</RowColumn>
		</ItemRow>
	);
};

ShopBagItemProduct.propTypes = {
	ix: PropTypes.number.isRequired,
	xoLink: PropTypes.string.isRequired,
	remove: PropTypes.func.isRequired,
	listing: PropTypes.object,
	store: PropTypes.object,
	cartProduct: PropTypes.shape({
		subscriptionTypeTerm: PropTypes.shape({
			id: PropTypes.number,
			name: PropTypes.string,
			numCycles: PropTypes.number,
		}),
		productInstance: PropTypes.shape({
			id: PropTypes.number,
			product: PropTypes.shape({
				id: PropTypes.number,
				billing: PropTypes.object,
				image: PropTypes.string,
				name: PropTypes.string,
				singlePurchasable: PropTypes.bool,
			}),
		}),
		listing: PropTypes.object,
		price: PropTypes.number,
		currencySymbol: PropTypes.string,
		quantity: PropTypes.number,
		id: PropTypes.number,
	}),
};

export default ShopBagItemProduct;
